import { axiosInstance } from "lib/axios";
import { citationAPI, searchAPI } from "services/apis.service";
import axios from "axios";
import Hashes from "jshashes";

const MD5 = Hashes.MD5();

export const fetchCitationStyles = async () => {
  const { data } = await axiosInstance.get(citationAPI.getCitationStyles);
  return data;
};

export const fetchCitationFields = async (user, currentItemType, selectedStyle = "apa") => {
  const { data } = await axiosInstance.post(
    searchAPI.GetCitationDynamicData,
    {
      user: user.userId,
      itemTypeId: currentItemType.id,
      style: selectedStyle,
    }
  );

  return data;
};

export const fetchCitationMetaData = async (signal, url) => {
  const { data } = await axiosInstance.post(
    citationAPI.getCitationMeta,
    url,
    {
      headers: {
        "Content-Type": "text/plain",
      },
      signal,
    }
  );
  return data;
};

export const fetchSavedCitationMeta = async (collectionSourceId, user) => {
  const { data } = await axiosInstance.post(
    searchAPI.getCitation,
    {
      collectionSourceId: collectionSourceId,
      userId: user.userId,
    },
    {
      cache: false,
    }
  );
  return data;
};

export const generateCitation = async (
  currentItemType,
  selectedStyle,
  articleData,
  authors
) => {
  const { day, month, ...restArticleData } = articleData;
  // If the date string doesn't include a year or isn't ND/n.d., we treat it as no-date
  const hasYear = (articleData.date || "").match(/\d{4}|ND|n\.d\./i);
  const filteredArticleData = hasYear
    ? articleData
    : { ...restArticleData, date: "" };

  const { data } = await axiosInstance.post(
    `${citationAPI.getCitation}?responseformat=html&style=${selectedStyle}`,
    {
      items: [
        {
          ...filteredArticleData,
          itemType:
            currentItemType.toLowerCase() === "webpage"
              ? "webpage"
              : currentItemType,
          styles: selectedStyle,
          key: articleData.key ? articleData.key : "VH$KV",

          ...(authors.length > 0 &&
            authors[0].firstName.length > 0 ? {
            creators: authors,
          } : {
            creators: []
          }),
        },
      ],
    },
    {
      cache: false,
    }
  );
  return data;
};

export const generateRISCitation = async (
  currentItemType,
  articleData,
  authors
) => {
  // Remove 'styles' field — not accepted by the RIS endpoint
  const { styles, ...cleanArticleData } = articleData;
  const { day, month, ...restCleanData } = cleanArticleData;
  // If the date string doesn't include a year or isn't ND/n.d., we treat it as no-date
  const hasYear = (cleanArticleData.date || "").match(/\d{4}|ND|n\.d\./i);
  const finalArticleData = hasYear
    ? cleanArticleData
    : { ...restCleanData, date: "" };

  const { data } = await axiosInstance.post(
    `${citationAPI.getCitation}?responseformat=ris`,
    {
      items: [
        {
          ...finalArticleData,
          itemType:
            currentItemType.toLowerCase() === "webpage"
              ? "webpage"
              : currentItemType,
          key: cleanArticleData.key ? cleanArticleData.key : "VH$KV",

          ...(authors.length > 0 &&
            authors[0].firstName.length > 0 ? {
            creators: authors,
          } : {
            creators: []
          }),
        },
      ],
    },
    {
      cache: false,
    }
  );
  return data;
};
